/* ============================================================
   Lost Collective · Article reading progress bar
   File: assets/lc-article-progress.js

   Binds #progressBar (in the masthead) and an injected mobile
   bar to scroll position. Independent of body postprocessing —
   runs on plain DOM ready so the hero indicator works even on
   articles without a populated body.
   ============================================================ */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') return fn();
    document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var bar = document.getElementById('progressBar');
    if (!bar) return;
    bar.style.width = '0%';

    var mobileBar = document.createElement('div');
    mobileBar.className = 'art-progress-mobile';
    mobileBar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(mobileBar);

    var article = document.querySelector('article.article') || document.body;
    var raf = null;

    function update() {
      var rect = article.getBoundingClientRect();
      var viewport = window.innerHeight;
      var articleHeight = article.scrollHeight;
      var scrolled = Math.max(0, -rect.top);
      var maxScroll = Math.max(1, articleHeight - viewport);
      var pct = Math.min(100, (scrolled / maxScroll) * 100);
      var w = pct.toFixed(2) + '%';
      bar.style.width = w;
      mobileBar.style.width = w;
    }

    function onScroll() {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = null;
        update();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  });
})();
